export default {
    date: null,
    time: null,
    times: [],
    freeTimes: [],
    fetching: false,
    member: null,
    members: [],
};
